import React from 'react';
import PropTypes from 'prop-types';
import COLORS from 'constants/colors';
import styled from 'styled-components';
import { Row, Col, Text } from '@cuemath/comps';
import { CheckboxChecked } from 'styled-icons/boxicons-solid/CheckboxChecked';

const CheckboxIcon = styled(CheckboxChecked)`
  color: ${COLORS.SKY};
  margin-right: 4px;
`;

const StyledCol = styled(Col)`
  max-width: 18px;
`;

const TextCol = styled(Col)`
  margin: auto 0px;
`;

const Options = ({ value }) => (
  <Row nowrap>
    <StyledCol>
      <CheckboxIcon size={24} />
    </StyledCol>
    <TextCol sm={11} xs={10}>
      <Text color={COLORS.COLA}>{value}</Text>
    </TextCol>
  </Row>
);

Options.propTypes = {
  value: PropTypes.string,
};

export default Options;
